import { useState } from 'react';

export default function usePortalContainer() {
  const [node] = useState(
    () => document.getElementById('root') ?? document.getElementById('storybook-root'),
  );
  return node;
}
